/**
 * Forbidden — 403 error page.
 *
 * Per J-X8: "You don't have access to this resource"; "Return to your workspace" CTA.
 *
 * Cross-cutting invariants:
 *   - Inv 12: no console.log
 *   - Inv 13: no `any`
 *   - Inv 14: internal CTAs via <Button onClick={navigate}>; mailto via <Link href="...">
 *   - Inv 15: atoms from @/components/ui barrel only (Button, Eyebrow, Heading, Link)
 */
import type { ReactElement } from 'react';
import { Button, Eyebrow, Heading, Link } from '@/components/ui';
import { ErrorPageChrome } from './ErrorPageChrome.tsx';
import { useNavigate } from 'react-router-dom';

export function ForbiddenPage(): ReactElement {
  const navigate = useNavigate();
  return (
    <ErrorPageChrome>
      <Eyebrow>403 Forbidden</Eyebrow>
      <Heading level="h1" className="mt-6">
        You don&apos;t have access to this resource.
      </Heading>
      <p className="mt-4 font-sans text-body-lg text-muted">
        You&apos;re signed in but don&apos;t have permission to view this page.
        If you believe this is an error, contact your workspace administrator.
      </p>
      <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
        <Button
          variant="primary"
          onClick={() => { void navigate('/dashboard'); }}
        >
          Return to your workspace
        </Button>
        <Link href="mailto:support@bimassess.com">
          Contact support
        </Link>
      </div>
    </ErrorPageChrome>
  );
}
